<ng-content select="button[sui-menu-item]"></ng-content>
